import util from '@bmp-vue/core/api/util'

const controller = 'ApiResources'
export default Object.assign({}, util.GetCrud(controller, null), {
  PostApiResourceScope: function (dto) {
    return util.Axios.Post(`${controller}/${dto.resourceName}/scopes`, dto)
  },
  PostApiResourceSecrets: function (dto) {
    return util.Axios.Post(`${controller}/${dto.resourceName}/secrets`, dto)
  },
  DeleteApiSecrets: function (dto) {
    return util.Axios.Delete(`${controller}`, `${dto.resourceName}/secrets?value=${encodeURIComponent(dto.value)}&type=${dto.type}`)
  },
  GetHashTypes: function () {
    return new Promise((resolve, reject) => {
      const array = [
        { text: 'Sha256', value: 0 },
        { text: 'Sha512', value: 1 }
      ]
      resolve(array)
    })
  }
})
